import React, { useEffect, useState } from 'react';
import Layout from './Layout';
import Table from './Table';
import Upload from './Upload';

import '../App.css';
import Alert from '@material-ui/lab/Alert';
import {Button} from '@material-ui/core';
import {CheckAuthSession} from '@dishtech-react/core';

export interface IItem {
  name: string
  model: string
  uploaded: string
  swid: string
  signed: boolean
}

const OutOfFlash = () => {
  const [rows, setRows] = useState<IItem[]>([]);
  const [fetches, setFetches] = useState<number>(0);
  const [err, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const refresh = () => setFetches(fetches + 1);
  useEffect(() => {
    setIsLoading(true);
    fetch('/api/files')
      .then(async res => {
        if (res.ok) {
          return res.json();
        } else {
          let msg = await res.text();
          throw new Error(msg)
        }
      })
      .then(({ data }) => {
        setIsLoading(false);
        setRows(data);
      }).catch(e => {
        setError(e.message || 'Failure to Get Files');
        setIsLoading(false);
      })

  }, [fetches]);
  return (
    <Layout>
      <CheckAuthSession/>
      <Upload refresh={() => setFetches(fetches + 1)} />
      {err && <Alert style={{ marginBottom: '1rem' }} severity="error" action={
        <Button onClick={refresh} color="inherit" size="small">
          Retry
        </Button>
      }>{err}</Alert>}
      <Table refresh={() => setFetches(fetches + 1)} rows={rows} isLoading={isLoading} />
    </Layout>
  );
};

export default OutOfFlash;
